import { Tree } from '@dreryk/react-components';

import { HealthcareBasicData } from '../../common/HealthcareBasicData';

import { HealthcareFacilityTreeItems } from './facility/HealthcareFacilityTreeItems';

type HealthcareOrganizationTreeProps = {
   readonly healthcareParentData: HealthcareBasicData;
};

export const HealthcareOrganizationTree = (props: HealthcareOrganizationTreeProps): JSX.Element => {
   return (
      <Tree testId={'healthcareOrganizationTree'}>
         <HealthcareFacilityTreeItems healthcareParentData={props.healthcareParentData} />
      </Tree>
   );
};
